import { PlanTier } from '@flagsync/skyline';

import { Pricing } from '@/pages/unauthenticated/pricing/components/types';

export const pricing: Pricing = {
  tiers: [
    {
      name: 'Startup',
      activeTier: PlanTier.Tier15,
      lookupKeys: [PlanTier.Tier1, PlanTier.Tier15],
      href: '/register',
      featured: false,
      maxSeats: 5,
      description:
        'The essential feature flag solution for teams just starting out.',
      price: { monthly: 5 },
      includes: 'Includes:',
      mainFeatures: [
        'Up to 5 seats (no min)',
        'Up to 10 flags',
        '2 environments',
        'Streaming SDKs',
        '10,000 MAUs',
        'Flag analytics',
      ],
    },
    {
      name: 'Team',
      activeTier: PlanTier.Tier210,
      lookupKeys: [PlanTier.Tier2, PlanTier.Tier210],
      href: '/register',
      featured: true,
      maxSeats: 25,
      description: 'Make data-driven decisions through A/B/n experimentation.',
      price: { monthly: 10 },
      includes: 'Everything in Startup, plus:',
      mainFeatures: [
        'Up to 25 seats (no min)',
        'Up to 50 flags',
        'Unlimited environments',
        '40,000 MAUs',
        'Live event tail',
        'Up to 5 experiments',
      ],
    },
    {
      name: 'Pro',
      activeTier: PlanTier.Tier320,
      lookupKeys: [PlanTier.Tier3, PlanTier.Tier320],
      href: '/register',
      featured: false,
      maxSeats: null,
      description: 'Scale your feature rollouts with unlimited everything.',
      price: { monthly: 20 },
      includes: 'Everything in Team, plus:',
      mainFeatures: [
        'Unlimited seats',
        'Unlimited flags',
        'Unlimited MAUs',
        'Unlimited workspaces',
        'Unlimited environments',
        'Unlimited experiments',
      ],
    },
  ],
  sections: [
    {
      name: 'Platform',
      features: [
        {
          name: 'Seats',
          tiers: { Startup: '5', Team: '25', Pro: 'Unlimited' },
        },
        {
          name: 'Feature flags',
          tiers: { Startup: '10', Team: '50', Pro: 'Unlimited' },
        },
        {
          name: 'Feature flag dashboard',
          tiers: { Startup: true, Team: true, Pro: true },
        },
        {
          name: 'Workspaces',
          tiers: {
            Startup: '1',
            Team: '2',
            Pro: 'Unlimited',
          },
        },
        {
          name: 'Environments',
          tiers: {
            Startup: '2',
            Team: 'Unlimited',
            Pro: 'Unlimited',
          },
        },
        {
          name: 'MAUs',
          tiers: {
            Startup: '10,000',
            Team: '40,000',
            Pro: 'Unlimited',
          },
        },
        {
          name: 'RBAC',
          tiers: { Startup: true, Team: true, Pro: true },
        },
      ],
    },
    {
      name: 'User Targeting',
      features: [
        {
          name: 'Individual targeting',
          tiers: { Startup: true, Team: true, Pro: true },
        },
        {
          name: 'Target by user attributes',
          tiers: { Startup: true, Team: true, Pro: true },
        },
        {
          name: 'Percentage rollouts',
          tiers: { Startup: true, Team: true, Pro: true },
        },
        {
          name: 'Unlimited flag targeting logic',
          tiers: { Startup: true, Team: true, Pro: true },
        },
        {
          name: 'Dynamic configurations',
          tiers: { Startup: true, Team: true, Pro: true },
        },
      ],
    },
    {
      name: 'Monitor and Experiment',
      features: [
        {
          name: 'Flag impression insights',
          tiers: {
            Startup: '30-day retention',
            Team: '90-day retention',
            Pro: '90-day retention',
          },
        },
        {
          name: 'Audit logging',
          tiers: {
            Startup: '30-day retention',
            Team: '90-day retention',
            Pro: '90-day retention',
          },
        },
        {
          name: 'Live event tail',
          tiers: { Startup: false, Team: true, Pro: true },
        },
        {
          name: 'Custom metric creation',
          tiers: { Startup: false, Team: true, Pro: true },
        },
        {
          name: 'A/B/n experiments',
          tiers: { Startup: false, Team: '5', Pro: 'Unlimited' },
        },
        {
          name: 'Data retention for experiment events',
          tiers: { Startup: false, Team: '90 days', Pro: '90 days' },
        },
      ],
    },
  ],
};
